<script lang="ts">
export default {
  name: 'KkCsvFileErrorModal',
}
</script>
<script setup lang="ts">
import { KkModal } from '../../../../components/base'
import { useI18n } from 'vue-i18n'
import type { CsvErrorAttribute, CsvErrorReason } from '../../../../domains/foodMenu/types'

type ImportError = {
  lineNumber: number | null,
  attr: CsvErrorAttribute,
  reason: CsvErrorReason,
}

const props = defineProps<{
  showModal: boolean,
  errors: ImportError[],
}>()

const { t } = useI18n()

type Emits = {
  (event: 'close-modal'): void;
}

const emits = defineEmits<Emits>()
const closeModal = (): void => {
  emits('close-modal')
}

const errorMessage = (attr: CsvErrorAttribute, reason: CsvErrorReason): string => {
  const attrText = t(`pages.CompaniesFoodMenus.uploadedFiles.errorModal.errors.attribute.${attr}`)
  const reasonText = t(`pages.CompaniesFoodMenus.uploadedFiles.errorModal.errors.reason.${reason}`)

  // baseは全体的なエラー（例: ホットペッパーのアイテム数が超過しています。）のため、理由だけを表示する
  if (attr !== 'base') {
    return t(
      'pages.CompaniesFoodMenus.uploadedFiles.errorModal.errorMessage',
      {
        attr: attrText,
        reason: reasonText
      }
    )
  } else {
    return reasonText
  }
}
</script>

<template>
  <KkModal :is-visible="props.showModal" @change="closeModal">
    <div class="p-modal__content__header">
      {{ t('pages.CompaniesFoodMenus.uploadedFiles.errorModal.errorCount', { value: props.errors.length }) }}
    </div>
    <div class="p-box__body">
      <div class="p-table__content">
        <table>
          <thead>
            <tr>
              <th>
                {{ t('pages.CompaniesFoodMenus.uploadedFiles.errorModal.line') }}
              </th>
              <th>
                {{ t('pages.CompaniesFoodMenus.uploadedFiles.errorModal.reason') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(error, i) in props.errors" :key="`error_${i}`">
              <td>
                {{
                  error.lineNumber !== null ?
                    t('pages.CompaniesFoodMenus.uploadedFiles.errorModal.errorLine', { value: error.lineNumber }) :
                    t('pages.CompaniesFoodMenus.uploadedFiles.errorModal.errorFile')
                }}
              </td>
              <td>
                {{ errorMessage(error.attr, error.reason) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </KkModal>
</template>

<style lang="scss" scoped>
@import '../../../../../../stylesheets/biz_spa/foundation/_var.scss';
.p-box__body {
  height: 400px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 50, .5);
    border-radius: 10px;
    box-shadow: 0 0 0 1px rgba(255, 255, 255, .3);
  }
}
</style>
